import { TopBookShelfSection } from './TopBookShelfSection'
import { withTopBookShelfSection } from './withTopBookShelfSection'

const ConnectedTopBookShelfSection =
  withTopBookShelfSection(TopBookShelfSection)
export { ConnectedTopBookShelfSection as TopBookShelfSection }
